// src/services/apaleo/properties.ts
// Extracted verbatim from src/services/apaleo.ts (Phase 5 of
// plans/monolith-migration-plan.md). `this` is typed via ThisType<ApaleoClient>.

import type { ApaleoClient } from './client-contract';
import { IS_DEV, MockData, ALLOWED_PROPERTIES } from './config';

const part: ThisType<ApaleoClient> = {
async fetchProperties() {
  if (IS_DEV) {
    return [
      { id: "BERLIN", name: "Berlin" },
      { id: "GIESSEN", name: "Gießen" },
      { id: "SIEGEN", name: "Siegen" },
      { id: "WETZLAR", name: "Wetzlar" }
    ];
  }
  try {
    const data = (await this._fetch("/inventory/v1/properties")) as
      | { properties?: unknown[] }
      | null;
    return data?.properties || [];
  } catch (error) {
    console.error("Fehler beim Laden der Properties:", error);
    return [];
  }
},

async fetchPropertyById(propertyId: string): Promise<unknown> {
  if (IS_DEV) {
    const names: Record<string, string> = {
      BERLIN: "Adapt Apartments Berlin",
      GIESSEN: "Adapt Apartments Gießen",
      SIEGEN: "Adapt Apartments Siegen",
      WETZLAR: "Adapt Apartments Wetzlar"
    };
    const addresses: Record<string, { addressLine1: string; city: string; postalCode: string; countryCode: string }> = {
      BERLIN: { addressLine1: "Erich-Thilo-Strasse 3", city: "Berlin", postalCode: "12489", countryCode: "DE" },
      GIESSEN: { addressLine1: "Licher Str. 12", city: "Gießen", postalCode: "35394", countryCode: "DE" },
      SIEGEN: { addressLine1: "Sandstraße 24", city: "Siegen", postalCode: "57072", countryCode: "DE" },
      WETZLAR: { addressLine1: "Karl-Kellner-Ring 9", city: "Wetzlar", postalCode: "35576", countryCode: "DE" }
    };
    const ibans: Record<string, string> = {
      BERLIN: "DE70100900002426039004",
      GIESSEN: "DE82370400440532013001",
      SIEGEN: "DE53370400440532013002",
      WETZLAR: "DE24370400440532013003"
    };
    const bics: Record<string, string> = {
      BERLIN: "BEVODEBBXXX",
      GIESSEN: "COBA DEFF XXX",
      SIEGEN: "WELT DEFF XXX",
      WETZLAR: "GENO DEFF XXX"
    };
    return {
      id: propertyId,
      code: propertyId,
      name: {
        de: names[propertyId] || `Adapt Apartments ${propertyId}`,
        en: names[propertyId] || `Adapt Apartments ${propertyId}`
      },
      companyName: "Adapt Apartments GmbH",
      location: addresses[propertyId] || { addressLine1: "Hauptstraße 10", city: "Berlin", postalCode: "10115", countryCode: "DE" },
      taxId: "DE285765189",
      bankAccount: {
        iban: ibans[propertyId] || "DE70100900002426039004",
        bic: bics[propertyId] || "BEVODEBBXXX",
        bank: "Adapt Bank"
      }
    };
  }
  return await this._fetch(`/inventory/v1/properties/${propertyId}`);
},

async fetchPropertyPerformance(
  propertyIdFilter: string | null,
  from: string | null,
  to: string | null,
): Promise<unknown[]> {
  if (IS_DEV) return MockData.MOCK_PROPERTY_PERFORMANCE;
  if (ALLOWED_PROPERTIES.length === 0) return [];

  const targetProps: string[] =
    propertyIdFilter === "All"
      ? ALLOWED_PROPERTIES
      : ALLOWED_PROPERTIES.includes(propertyIdFilter ?? "")
        ? [propertyIdFilter ?? ""]
        : [];

  const promises = targetProps.map((id) =>
    this._fetch(
      `/reports/v1/reports/property-performance?propertyId=${id}&from=${from}&to=${to}&expand=businessDays`,
    )
      .then((data) => ({
        ...(data as Record<string, unknown>),
        propertyId: id,
        success: true,
      }))
      .catch(() => ({ success: false, id })),
  );

  const results = await Promise.all(promises);
  return results.filter((r) => r.success);
},

};

export default part;
